'use client'

import { useEffect, useState } from 'react'
import { useLocale } from 'use-intl'
import { useTranslations } from 'next-intl'
import { FloatingDelayGroup } from '@floating-ui/react'
import { Expert } from '@/shared/ui/expert'
import { IPerson } from '@/interfaces/persons'
import { getExperts } from '@/actions/getPersons'
import { SearchableSelect } from '@/shared/ui/select'
import { localeMap } from '@/shared/utils/directus'
import BirdEmptyResult from '@/public/bird-empty-result.svg'
import { Text } from '@/shared/ui'
import styles from './experts-searchable.module.scss'
import { SearchExperts } from '../search-experts'

type Option = {
  value: string | number
}

interface ExpertsSearchableProps {
  options: Option[]
  experts: IPerson[]
}

export const ExpertsSearchable = (props: ExpertsSearchableProps) => {
  const { options, experts } = props
  const [loading, setLoading] = useState(false)
  const [countryId, setCountryId] = useState<string>('')
  const [list, setList] = useState<IPerson[]>(experts)
  const [inputValue, setInputValue] = useState('')

  const currentLocale = useLocale()
  useEffect(() => {
    setLoading(true)
    getExperts({ locale: localeMap[currentLocale], countryId: countryId ? countryId : undefined })
      .then(newItems => {
        setList(newItems)
      })
      .catch(error => {
        // TODO: По хорошему тут бы показать тостер пользователю, что что-то пошло не так
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [countryId, currentLocale])
  // TODO: нужно добавить склетов для отображения состояния загрузки
  const translate = useTranslations()
  const filteredExpert = list.filter(expert => expert?.name?.toLowerCase().includes(inputValue?.toLowerCase()))

  return (
    <>
      <div className={styles.controls}>
        <SearchableSelect
          className={styles.select}
          options={options}
          placeholder={translate('countries')}
          emptyMessage={translate('emptyMessage')}
          onChange={itemOption => {
            const option = itemOption as Option | null

            setCountryId(String(option?.value ?? ''))
          }}
        />
        <SearchExperts
          value={inputValue}
          onChange={setInputValue}
          placeholder={translate('inputPlaceholderSearchForExperts')}
        />
      </div>
      {filteredExpert?.length && filteredExpert?.length > 0 ? (
        <ul className={styles.list}>
          {filteredExpert.map(person => (
            <FloatingDelayGroup delay={100} key={person.id}>
              <Expert person={person} role="" searchValue={inputValue} />
            </FloatingDelayGroup>
          ))}
        </ul>
      ) : (
        <div className={styles.emptyResultWrapper}>
          <div className={styles.birdEmptyResult}>
            <BirdEmptyResult />
          </div>
          <Text className={styles.emptyResultText} type="h2" color="dark-040" __html={translate('emptyResult')} />
        </div>
      )}
    </>
  )
}
